import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardCrm from "../pages/DashboardCrm";
import DashboardEcommerce from "../pages/DashboardEcommerce";

import DashboardCrypto from "../pages/DashboardCrypto";
import DashboardProject from "../pages/DashboardProject";

//Calendar
// Email box
import MailInbox from "../pages/EmailInbox";

//CHat
import Chat from "../pages/Chat";
import Calendar from "../pages/Calendar";

// Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";

//Task
import TaskDetails from "../pages/Tasks/TaskDetails";
import TaskList from "../pages/Tasks/TaskList";
import KanbanBoard from "../pages/Tasks/KanbanBoard/Index";

//Transactions
import Transactions from '../pages/Crypto/Transactions';
import BuySell from '../pages/Crypto/BuySell';
import CryproOrder from '../pages/Crypto/CryptoOrder';
import MyWallet from '../pages/Crypto/MyWallet';
import ICOList from '../pages/Crypto/ICOList';
import KYCVerification from '../pages/Crypto/KYCVerification';

//Crm Pages
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CrmContacts from "../pages/Crm/CrmContacts";
import CrmDeals from "../pages/Crm/CrmDeals/index";
import CrmLeads from "../pages/Crm/CrmLeads/index";

//Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";

// Support Tickets
import ListView from '../pages/SupportTickets/ListView';
import TicketsDetails from '../pages/SupportTickets/TicketsDetails';

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceSellers from "../pages/Ecommerce/EcommerceSellers/index";
import EcommerceSellerDetail from "../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail";

// Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// Advance Ui
import UiNestableList from "../pages/AdvanceUi/UiNestableList/UiNestableList";
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiTour from "../pages/AdvanceUi/UiTour/UiTour";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// Widgets
import Widgets from '../pages/Widgets/Index';

//Forms
import BasicElements from "../pages/Forms/BasicElements/BasicElements";
import FormSelect from "../pages/Forms/FormSelect/FormSelect";
import FormEditor from "../pages/Forms/FormEditor/FormEditor";
import CheckBoxAndRadio from "../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio";
import Masks from "../pages/Forms/Masks/Masks";
import FileUpload from "../pages/Forms/FileUpload/FileUpload";
import FormPickers from "../pages/Forms/FormPickers/FormPickers";
import FormRangeSlider from "../pages/Forms/FormRangeSlider/FormRangeSlider";
import Formlayouts from "../pages/Forms/FormLayouts/Formlayouts";
import FormValidation from "../pages/Forms/FormValidation/FormValidation";
import FormWizard from "../pages/Forms/FormWizard/FormWizard";
import FormAdvanced from "../pages/Forms/FormAdvanced/FormAdvanced";

//Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
import GridTables from '../pages/Tables/GridTables/GridTables';
import ListTables from '../pages/Tables/ListTables/ListTables';

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";

//Maps
import GoogleMaps from "../pages/Maps/GoogleMaps/GoogleMaps";
import VectorMaps from "../pages/Maps/VectorMaps/VectorMaps";
import LeafletMaps from "../pages/Maps/LeafletMaps/LeafletMaps";

//AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
//pages
import Starter from '../pages/Pages/Starter/Starter';
import SimplePage from '../pages/Pages/Profile/SimplePage/SimplePage';
import Settings from '../pages/Pages/Profile/Settings/Settings';
import Team from '../pages/Pages/Team/Team';
import Timeline from '../pages/Pages/Timeline/Timeline';
import Faqs from '../pages/Pages/Faqs/Faqs';
import Pricing from '../pages/Pages/Pricing/Pricing';
import Gallery from '../pages/Pages/Gallery/Gallery';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import SiteMap from '../pages/Pages/SiteMap/SiteMap';
import SearchResults from '../pages/Pages/SearchResults/SearchResults';

import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from '../pages/AuthenticationInner/Logout/BasicLogout';
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';



//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import CardDetails from "../FindagramAdmin/Payment/CardDetails";
import SubscriptionDetails from "../FindagramAdmin/Payment/SubscriptionDetails";
import UpgradeSubscription from "../FindagramAdmin/Payment/UpgradeSubscription";




//-----------------Bitesaver---------

import BusinessProfile from "../FindagramAdmin/Profile/BusinessProfile";
import BPEdit from "../FindagramAdmin/Profile/BPEdit";

import ProfileSetup from "../FindagramAdmin/Profile/ProfileSetup";

import AddDailySpecial from "../FindagramAdmin/Deals/AddDailySpecial";
import DealList from "../FindagramAdmin/Deals/DealList";

import DSDealDeatail from "../FindagramAdmin/Deals/DSDealDetail";
import UpdateDSDeal from "../FindagramAdmin/Deals/UpdateDSDeal";


import UserSubscription from "../FindagramAdmin/AdminPages/UserSubscription";

import ResetPassword from "../pages/Authentication/ResetPassword";

import UpdateSubscriptionType from "../FindagramAdmin/AdminPages/UpdateSubscriptionType";
import { Card } from "reactstrap";
import AddLunchSpecial from "../FindagramAdmin/LunchDeals/AddLunchSpecial";
import LunchDealList from "../FindagramAdmin/LunchDeals/LunchDealList";
import LSDealDetail from "../FindagramAdmin/LunchDeals/LSDealDetail";
import UpdateLSDeal from "../FindagramAdmin/LunchDeals/UpdateLSDeal";


import AddHH from "../FindagramAdmin/HappyHours/AddHH";
import HHList from "../FindagramAdmin/HappyHours/HHList";
import HHDetail from "../FindagramAdmin/HappyHours/HHDetail";
import UpdateHH from "../FindagramAdmin/HappyHours/UpdateHH";


import AddLimitedTimeDeal from "../FindagramAdmin/LimitedTimeDeals/AddLimitedTimeDeal";
import LimitedTimeDealList from "../FindagramAdmin/LimitedTimeDeals/LimitedTimeDealList";
import LTDealDetail from "../FindagramAdmin/LimitedTimeDeals/LTDealDetail";
import UpdateLTDeal from "../FindagramAdmin/LimitedTimeDeals/UpdateLTDeal";





const authProtectedRoutes = [


//------------------ Bitesaver-------------
{ path: "/business-profile", component: BusinessProfile },
{ path: "/business-profile-edit", component: BPEdit },

{ path: "/profile-setup", component: ProfileSetup},


{ path: "/add-daily-special", component: AddDailySpecial },
{ path: "/deal-list", component: DealList},
{ path: "/deal/:dealId", component: DSDealDeatail },
{ path: "/edit-deal/:dealId", component: UpdateDSDeal  },


{ path: "/add-lunch-special", component: AddLunchSpecial },
{ path: "/lunch-deal-list", component: LunchDealList},
{ path: "/lunch-deal/:dealId", component: LSDealDetail },
{ path: "/edit-lunch-deal/:dealId", component: UpdateLSDeal  },


{ path: "/add-happy-hour-deal", component: AddHH },
{ path: "/happy-hour-deal-list", component: HHList},
{ path: "/happy-hour-deal/:dealId", component: HHDetail },
{ path: "/edit-happy-hour-deal/:dealId", component: UpdateHH  },


{ path: "/add-limited-time-deal", component: AddLimitedTimeDeal },
{ path: "/limited-time-deal-list", component: LimitedTimeDealList},
{ path: "/limited-time-deal/:dealId", component: LTDealDetail },
{ path: "/edit-limited-time-deal/:dealId", component: UpdateLTDeal  },
// { path: "/deal", component: DSDealDeatail},

// { path: "/categories", component: Categories },

// { path: "/add-card-details", component: CardDetails },
{ path: "/subscription-detail", component: SubscriptionDetails },
// { path: "/upgrade-subscription", component: UpgradeSubscription },




{ path: "/bascic-tables", component: BasicTables },
{ path: "/grid-tables", component: GridTables },
{ path: "/list-tables", component: ListTables },

// aqdas

{ path: "/form-basic-elements", component: BasicElements },
{ path: "/form-select", component: FormSelect },
{ path: "/form-editor", component: FormEditor },
{ path: "/form-checkbox-radio", component: CheckBoxAndRadio },
{ path: "/form-masks", component: Masks },
{ path: "/form-file-upload", component: FileUpload },
{ path: "/form-pickers", component: FormPickers },
{ path: "/form-range-slider", component: FormRangeSlider },
{ path: "/form-layouts", component: Formlayouts },
{ path: "/form-validation", component: FormValidation },
{ path: "/form-wizard", component: FormWizard },
{ path: "/form-advanced", component: FormAdvanced },

// aqdas end


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/business-profile" />,
  },
];

const publicRoutes = [
    // Authentication Page
    { path: "/logout", component: Logout },
    { path: "/login", component: Login },
    { path: "/forgot-password", component: ForgetPasswordPage },
    { path: "/register", component: Register },
    { path: "/reset-password", component: ResetPassword},


      //  { path: "/add-card-details", component: CardDetails},
  


];

export { authProtectedRoutes, publicRoutes };